
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"m13.033 4.849-7.311-3.534A2.254 2.254 0 0 0 5 1a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0v-4.307l7-3.026a1 1 0 0 0 .033-1.818Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  